import React from "react";

import CountUp  from "react-countup";

const Stats = [
  { count: "5K", label: "Active Students" },
  { count: "10+", label: "Mentors" },
  { count: "200+", label: "Courses" },
  { count: "50+", label: "Awards" },


     
];




const StatsComponenet = () => {

  
  return (
    <div className="bg-blue-50 ">
      {/* Stats */}
      <div className="flex flex-row gap-10  justify-center items-center w-11/12 max-w-maxContent  text-white mx-auto ">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center justify-center">
      
    <div className="flex flex-col py-10 " >
  <h1 className="text-[30px] font-bold text-richblack-5">
  <CountUp
      start={0}
      end={5000}
      delay={0}
      enableScrollSpy={true}
      scrollSpyDelay={500}
    >
      {({ countUpRef }) => (
        <div className="counter">
          <span ref={countUpRef} />+
        </div>
      )}
    </CountUp>
  </h1>
  <h2 className="font-semibold text-[16px] text-richblack-500">
  Active Students
  </h2>
</div>
    <div className="flex flex-col py-10 " >
  <h1 className="text-[30px] font-bold text-richblack-5">
  <CountUp
      start={0}
      end={50}
      delay={0}
      enableScrollSpy={true}
      scrollSpyDelay={500}
    >
      {({ countUpRef }) => (
        <div className="counter">
          <span ref={countUpRef} />+
        </div>
      )}
    </CountUp>
  </h1>
  <h2 className="font-semibold text-[16px] text-richblack-500">
    Mentors
  </h2>
</div>
    <div className="flex flex-col py-10 " >
  <h1 className="text-[30px] font-bold text-richblack-5">
  <CountUp
      start={0}
      end={40}
      delay={0}
      enableScrollSpy={true}
      scrollSpyDelay={500}
    >
      {({ countUpRef }) => (
        <div className="counter">
          <span ref={countUpRef} />+
        </div>
      )}
    </CountUp>
  </h1>
  <h2 className="font-semibold text-[16px] text-richblack-500">
   Courses
  </h2>
</div>
    <div className="flex flex-col py-10" >
  <h1 className="text-[30px] font-bold text-richblack-5">
  <CountUp
      start={0}
      end={25}
      delay={0}
      enableScrollSpy={true}
      scrollSpyDelay={500}
    >
      {({ countUpRef }) => (
        <div className="counter">
          <span ref={countUpRef} />+
        </div>
      )}
    </CountUp>
  </h1>
  <h2 className="font-semibold text-[16px] text-richblack-500">
  Awards
  </h2>
</div>
    </div>
  
        </div>
      </div>
   
  );
};

export default StatsComponenet;
